import {CssTheme} from '@ui/themes/css-theme';

export function getThemeLogo(theme?: CssTheme | null): string | undefined {
  if (!theme) return undefined;

  const values = theme.values ?? {};
  const legacyColors = (theme as CssTheme & {colors?: Record<string, string>})
    .colors ?? {};

  return (
    values['--be-logo-light'] ||
    values['--be-logo-dark'] ||
    legacyColors['--be-logo-light'] ||
    legacyColors['--be-logo-dark'] ||
    undefined
  );
}
